import { Card } from '@/components/ui/card';
import { Settings2 } from 'lucide-react';
import type { CapabilityDefault } from '@/types';

interface DefaultsTabProps {
    defaults?: CapabilityDefault[];
}

export function DefaultsTab({ defaults }: DefaultsTabProps) {
    if (!defaults || defaults.length === 0) {
        return (
            <Card className="p-12 text-center">
                <div className="flex flex-col items-center gap-3">
                    <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-slate-100">
                        <Settings2 size={24} className="text-slate-400" />
                    </div>
                    <p className="text-slate-500">No defaults configured</p>
                </div>
            </Card>
        );
    }

    return (
        <div className="space-y-2">
            {defaults.map((d) => (
                <Card key={d.id} className="p-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-100">
                                <Settings2 size={14} className="text-emerald-600" />
                            </div>
                            <div className="flex items-center gap-2">
                                <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700">
                                    {d.env}
                                </span>
                                <span className="text-sm text-slate-700">
                                    Major version: <span className="font-semibold">{d.default_major}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    );
}
